import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';
import { useMusic24Plan } from '../../hooks/useMusic24Plan';

/** The store that bills a Music24 plan. */
export type PlanStore = 'appStore' | 'googlePlay';

/**
 * The store of the active workspace's paid plan when the App Store or Google Play bills it, else
 * null. It reads `billing.monthlyAddOns` (every member may read it; the Settings add-ons section
 * shares the cached answer). Free and the trial have no store plan, so they send no request. While
 * the answer loads, the value is null.
 */
export function usePlanStore(): PlanStore | null {
  const trpcAPI = useTRPCAPI();
  const plan = useMusic24Plan();
  const paid = plan !== 'free' && plan !== 'trial';
  const query = useTRPCQuery(trpcAPI.billing.monthlyAddOns.queryOptions(undefined, { retry: false, enabled: paid }));
  return paid ? (query.data?.store ?? null) : null;
}
